import { Container } from '@mui/material';
import { FeatureTaxonomy } from '../sections/Taxonomy';
import Metatags from '../components/MetaTags/MetaTags';

function TaxonomyViewerPage({ permissions }) {
  return (
    <>
      <Metatags metaTagName="Feature Usage | ISV Insights" />
      <Container maxWidth="xl">
        <FeatureTaxonomy permissions={permissions} />
      </Container>
    </>
  );
}

export default TaxonomyViewerPage;
